import { render, staticRenderFns } from "./CampaignDonation.vue?vue&type=template&id=ec078870"
import script from "./CampaignDonation.vue?vue&type=script&lang=js"
export * from "./CampaignDonation.vue?vue&type=script&lang=js"
import style0 from "./CampaignDonation.vue?vue&type=style&index=0&id=ec078870&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports